import { render } from "./ActivateEmailBanner.vue?vue&type=template&id=20a82c22"
import script from "./ActivateEmailBanner.vue?vue&type=script&lang=js"
export * from "./ActivateEmailBanner.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__